// Reusable section eyebrow label
export default function SectionLabel({ children, dark = false }) {
  return (
    <div className="flex items-center gap-4 mb-6">
      <span className={`gold-divider ${dark ? '' : ''}`} />
      <span
        className={`text-[11px] tracking-luxury uppercase font-medium ${
          dark ? 'text-gold-soft' : 'text-gold'
        }`}
      >
        {children}
      </span>
    </div>
  );
}
